import { NoEmitOnErrorsPlugin } from 'webpack';
import { base } from './base';

export const theme = {
  ...base,
  flex: {
    column: {
      flexDirection: 'column',
    },
    row: {
      flexDirection: 'row',
    },
    collapse: {
      flexDirection: ['column', 'row'],
    },
  },
  forms: {
    ...base.forms,
    input: {
      ...base.forms.input,
      height: '50px',
      borderColor: 'border',
      borderRadius: 0,
    },
    textarea: {
      ...base.forms.input,
      height: '400px',
      borderColor: 'border',
      borderRadius: 0,
    },
    select: {
      background: 'transparent',
      borderRadius: '0',
      borderColor: 'border',
      height: '50px',
    },
    checkbox: {
      height: '22px',
      width: '22px',
    },
  },
  a: {
    noUnderline: {
      variant: 'styles.a',
      textDecoration: 'none',
    },
    nav: {
      variant: 'styles.a',
      width: 'auto',
      color: 'text',
      '&.active': {
        color: 'text',
      },
      fontSize: [3, 3, 3],
      textDecoration: 'none',
    },
  },
  text: {
    ...base.text,
    default: {
      fontFamily: 'body',
      lineHeight: 'body',
      fontWeight: 'body',
      letterSpacing: 'body',
    },
    hint: {
      fontFamily: 'body',
      fontWeight: 'bold',
      fontSize: 0,
      color: 'border',
    },
    info: {
      fontFamily: 'body',
      fontSize: 0,
      color: 'secondary',
    },
  },
  buttons: {
    base: {
      minHeight: '50px',
      minWidth: '50px',
      cursor: 'pointer',
      color: 'black',
      lineHeight: '1.333',
      borderRadius: 0,
      letterSpacing: 1.1,
      flexShrink: 0,
    },
    primary: {
      variant: 'buttons.base',
      bg: 'green',
      fontWeight: 'body',
    },
    round: {
      variant: 'buttons.base',
      borderRadius: '40px',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'border',
      bg: 'hinted',
      color: 'text',
    },
    icon: {
      cursor: 'pointer',
      p: 1,
    },
    close: {
      cursor: 'pointer',
    },
    menu: {
      cursor: 'pointer',
    },
    highlight: {
      variant: 'buttons.primary',
      color: 'background',
      bg: 'text',
      borderColor: 'background',
    },
    tab: {
      variant: 'buttons.primary',
      minHeight: 'unset',
      color: 'primary',
      px: 1,
      py: 1,
      my: 1,
      fontSize: 2,
      borderColor: 'green',
      borderBottomWidth: '2px',
      borderStyle: 'solid',
      bg: 'transparent',
    },
    tabFaded: {
      variant: 'buttons.tab',
      borderBottomColor: 'transparent',
      color: 'secondary',
    },
    statusButton: {
      variant: 'buttons.primary',
      '&:disabled': {
        variant: 'buttons.disabled',
      },
    },
    miniStatusButton: {
      variant: 'buttons.statusButton',
      '&:disabled': {
        cursor: 'default',
        bg: 'muted',
        opacity: 0.8,
        pointerEvents: 'none',
        color: 'border',
      },
      minHeight: 'unset',
      px: 2,
      my: 0,
      mx: 1,
      py: 1,
    },
    radioButton: {
      variant: 'buttons.primary',
      minHeight: 'unset',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'border',
      mr: '-1px',
      px: 3,
      my: 0,
      py: 2,
      color: 'background',
      bg: 'primary',
    },
    radioFaded: {
      variant: 'buttons.radioButton',
      bg: 'background',
      color: 'primary',
    },
    disabled: {
      variant: 'buttons.primary',
      cursor: 'default',
      bg: 'muted',
      opacity: 0.8,
      pointerEvents: 'none',
      color: 'border',
    },
    max: {
      variant: 'buttons.base',
      minWidth: 'unset',
      minHeight: 'unset',
      color: 'background',
      bg: 'text',
      borderColor: 'background',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderRadius: 4,
      fontSize: 1,
      px: 2,
      py: 2,
      lineHeight: '1.25em',
      '&:disabled': {
        bg: 'muted',
        color: 'border',
        opacity: 0.8,
      },
    },
    link: {
      minWidth: 'unset',
    },
  },
  cards: {
    primary: {
      bg: 'hinted',
      px: [4, 6],
      py: [5, 6],
      my: [2],
      display: 'flex',
      flexDirection: 'column',
      fontSize: [2, 2, 2, 2],
    },
    small: {
      fontSize: 1,
      py: 3,
      px: 3,
      my: 2,
      bg: 'darkened',
    },
  },
  boxes: {
    fullscreen: {
      position: 'fixed',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      width: '100%',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      bg: 'background',
    },
    fullscreenMobileFill: {
      variant: 'boxes.fullscreen',
      minHeight: 'fill-available',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      thead: {
        textAlign: 'left',
      },
    },
  },
  layout: {
    header: {
      variant: 'layout.container',
      maxWidth: 'auto',
      py: [3, 2],
      px: [3, 5, 6],
    },
    container: {
      maxWidth: 920,
      mx: 'auto',
      px: '15px',
    },
    footer: {
      variant: 'layout.container',
    },
  },
  box: {
    error: {
      borderStyle: 'solid',
      borderColor: 'red',
      borderWidth: '1px',
      color: 'red',
      p: 3,
    },
    success: {
      borderStyle: 'solid',
      borderColor: 'green',
      borderWidth: '1px',
      color: 'green',
      p: 3,
    },
  },
};
